<template>
    <div>
        <v-card
                v-if="!map"
                class="flex"
                flat
                tile
        >
            <v-card-title >
                <v-btn color="primary" depressed block large   @click.stop="createMap()">VER MAPA</v-btn>
            </v-card-title>

        </v-card>

        <div id="mapCaixa" v-if="fab" style="height: calc(90vh)"></div>

        <v-btn @click="maps()" v-if="map" style="position: absolute; z-index: 2000; bottom: 50px"
               color="black"
               v-model="fab"
               dark
               fab
               bottom
               right
        >
            <v-icon>navigation</v-icon>
        </v-btn>
    </div>
</template>

<script>
    /* global L */
    import { LMap, LTileLayer, LMarker } from "vue2-leaflet"

    export default {
        name: "MapCaixa",
        components: { LMap, LTileLayer, LMarker },
        props: {
            lat: {
                default: null
            },
            lng: {
                default: null
            }
        },
        data () {
            return {
                fab: false,
                map: null,
                center: null
            }
        },
        beforeDestroy () {
            this.map = null;
        },
        methods: {
            maps: function () {
                window.open("https://www.google.com/maps/dir/?api=1&destination=" + this.lat + "," + this.lng)
            },
            createMap () {
                this.fab = true;
                setTimeout(() => {
                    this.map = L.map(document.getElementById("mapCaixa"), {
                        center: [this.lat, this.lng],
                        zoom: 15
                    });

                    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    }).addTo(this.map);

                    L.marker([this.lat, this.lng])
                        .addTo(this.map)
                        .openPopup();
                }, 1000);
            }
        }
    }
</script>

<style scoped>

</style>
